<template>
    <basic-header
        pretitle="Administration"
        title="Products"
        buttonText="Add Product"
        buttonIconClass="fa fa-plus me-1"
        @btnClick="showModal({ component: 'addProduct'})"
        :buttonRoles="addProductRoles"
    />
    <div class="container-fluid">
        <div class="card catalog-reveal">
            <Datatable
                tableId="productTable"
                :columns="columns"
                uniqueField ="product_id"
                :data="$store.state.admin.products"
                @deleteRows="showDeleteProducts"
                :deletable="$store.getters.userRoles.isAqferAdmin"
                :compact="true"
                :selectCheckboxes="$store.getters.userRoles.isAqferAdmin"
                :detailColumn="{renderBaseUrl: (data) => `/admin/products/${encodeURIComponent(data.name)}/versions/${data.version}`, renderParams: (data) => ({name: data.name, version: data.version}), name: 'Product'}"
            />
        </div>
    </div>
</template>
<script>
import Datatable from '../../components/Datatable.vue';
import BasicHeader from '../../components/BasicHeader.vue';
import { mapActions } from 'vuex';
import { nameCell, versionCell, codeCell, durationCell } from '../../utils/catalogCells';
export default{
    name: "Products",
    components:{ BasicHeader, Datatable},
    data(){
        return {
            columns:[
                { data: "sku", render: codeCell },
                { data: "name", render: nameCell },
                { data: "version", render: versionCell },
                { data: "duration", render: durationCell }
            ],
            addProductRoles: [1]
        };
    },
    beforeMount(){
        this.$store.dispatch("admin/fetchProducts");
    },
    methods: {
        showDeleteProducts(rows){
            this.showModal({ component: "deleteProducts", data:rows });
        },
        ...mapActions({
            showModal:"showModal"
        })
    }
}

</script>
<style lang="scss">
@import './catalog.scss';
</style>
